// Tipo MIME del archivo de importación (Excel más adelante)
export const IMPORT_EXPEDIENT_FILE_MIME = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' as const

export interface ResponseFile {
  downloadUrl: string
}

export interface FileStreamResponse {
  /** Stream de datos del archivo - puede ser Blob para archivos binarios, ArrayBuffer para datos en memoria, o string para archivos de texto */
  data: Blob | ArrayBuffer | string
  /** Headers HTTP de la respuesta, útiles para extraer información del archivo como Content-Type, Content-Disposition, etc. */
  headers?: Record<string, string>
  /** Código de estado HTTP de la respuesta */
  status: number
}

export interface UploadImportFileResponse {
  importId?: string
  success: boolean
  emptyContentError?: boolean
}

export interface ExecuteImportResponse {
  success: boolean
  importId?: string
  successCount?: string
  failureCount?: string
  totalCount?: string
}

export interface ImportSummary {
  summaryError?: boolean
  successCount: number
  failureCount: number
}
